import { TableColumnsDto } from '../../../models/dtos/tableColumns.dto';
import axios from '../../axios';

export default async function getSubCompaniesRequest(tableName: string): Promise<TableColumnsDto> {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/table-config/single`, {
    params: {
      tableKey: tableName
    }
  })
  return response.data;
}
